module.exports = __webpack_public_path__ + "img/swiper_03.2b6d60a8.jpg";